import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function PaginationNav({
  pageIndex = 1,
  pageCount = 1,
  onPageChange,
}) {
  return (
    <div className="flex items-center gap-3">
      <button
        onClick={() => onPageChange(pageIndex - 1)}
        disabled={pageIndex <= 1}
        className="flex items-center gap-2 px-4 py-2 border rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
      >
        <FaChevronLeft />
        Previous
      </button>

      <span className="text-sm font-medium">
        Page {pageIndex} of {pageCount}
      </span>

      <button
        onClick={() => onPageChange(pageIndex + 1)}
        disabled={pageIndex >= pageCount}
        className="flex items-center gap-2 px-4 py-2 border rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
      >
        Next
        <FaChevronRight />
      </button>
    </div>
  );
}

export default PaginationNav;